/**
 * Browser-safe stub for `create-plugin-meta.ts`.
 *
 * The real implementation uses Node.js builtins (`node:module`, `node:path`,
 * `node:url`) to resolve package.json version and icon paths at module load
 * time. In the browser, plugin metadata is served by the API — the client
 * never reads these values directly. Plugin `register.ts` files import the
 * plugin definition only to access `.web`, which is a static object that
 * doesn't depend on `meta`.
 *
 * `migrationsFolder` is returned as the empty string: the browser never runs
 * Drizzle migrations, and `definePlugin` consumers only read it inside
 * `server:` (also never reached in the browser bundle). It exists on the stub
 * solely so the return type matches the Node implementation.
 *
 * Vite's resolve alias in `web/vite.config.ts` swaps the real module for
 * this stub so `node:module` is never pulled into the browser bundle.
 */
export function createPluginMeta(_importMetaUrl: string): {
  version: string;
  dir: string;
  iconPath: string;
  migrationsFolder: string;
} {
  return { version: '0.0.0', dir: '', iconPath: '', migrationsFolder: '' };
}
